import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Token from './../models/Token';
import User from './../models/User';
import * as Msal from "msal";
import CONFIG from '../constants/Config';
import { message } from 'antd';
import i18n from "../constants/initLng";

export const msalInstance = new Msal.UserAgentApplication(CONFIG.AD_INFO.INFO);

let pendingRedirectResponse = null
let pendingRedirectError = null

msalInstance.handleRedirectCallback((error, response) => {
    if (error) {
        pendingRedirectError = error
    } else {
        pendingRedirectResponse = response
    }
})

export function consumePendingRedirectResponse() {
    const response = pendingRedirectResponse
    const error = pendingRedirectError
    pendingRedirectResponse = null
    pendingRedirectError = null
    if (error) throw error
    return response
}

export function login(accessToken) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.LOGIN,
        parser: (data) => new Token(data),
    }).post(accessToken);
}

export async function getAuthToken() {
    const pending = consumePendingRedirectResponse()
    if (pending?.accessToken && pending?.tokenType === 'access_token') {
        return pending
    }

    const account = msalInstance.getAccount()
    if (!account) return false

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...CONFIG.AD_INFO.REQUEST,
            account: account,
            loginHint: account?.userName || account?.sid,
            authority: msalInstance.authority,
        })
        return response
    } catch (error) {
        return false
    }
}

export function handleRedirectCallback() {
    return new Promise((resolve, reject) => {
        msalInstance.handleRedirectCallback((error, response) => {
            if (error) {
                reject(error);
            } else {
                resolve(response);
            }
        });
    });
}

export function getAuthAccount() {
    return Promise.resolve(msalInstance.getAccount());
}

export function loginAd() {
    try {
        const account = msalInstance.getAccount();
        if (account) {
            msalInstance.acquireTokenRedirect(CONFIG.AD_INFO.REQUEST);
        } else {
            msalInstance.loginRedirect(CONFIG.AD_INFO.REQUEST);
        }
        return Promise.resolve();
    } catch (error) {
        return Promise.reject(error);
    }
}

export function setActiveAccount(account) {
    msalInstance.setActiveAccount(account);
}

// export function login(accessToken){
//     return new ApiService({
//         baseURL: Config.API_IDENTITY,
//         endpoint: Urls.LOGIN,
//         parser: (data) => new Token(data),
//     }).post({accessToken});
// }

export function logoutAd() {
    msalInstance.logout();
}

export function logout() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.LOGOUT,
    }).get();
}

export function getUserProfile() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.PROFILE,
        parser: data => new User(data.data),
    }).get();
}

export function refreshToken(refreshToken) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.REFRESH,
        withoutAuth: true,
        parser: (data) => new Token(data),
    }).post({ refreshToken });
}